const { returnableDrugs } = require('@/api/returned')
module.exports = {
  'entityName': 'siterequest_has_drug',
  id: ['siterequest_id', 'drug_id'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'descending': true
  },
  'fields': [

    // il farmaco da trasferire dal centro source
    {
      'value': 'drug_id',
      'text': 'Drug',
      list: (entity, search, item) => returnableDrugs(search, item.protocol_id, item.site_source_id),
      'type': 'autocomplete',
      'title': 'name',
      id: 'drug_id',
      subtitle: drug => drug.packaging !== 'Labels' ? `${drug.packaging}, ${drug.dose}${drug.measure_unit} (${drug.n_available})` : `${drug.packaging} - ${drug.labels?.join(',')}`,
      'table': true,
      render: ({drug}) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      validators: ['required']
    },
    {
      value: '_n_available',
      text: 'N. Available',
      deps: ['drug_id'],
      default: (item, args, selected) => {
        item.drug = selected
        return selected && Number(selected.n_available)
      },
      visible: true,
      type: 'hidden'
    },
    {
      value: '_n_box',
      text: 'N. box',
      deps: ['drug_id'],
      visible: (item) => !(item.drug && item.drug.packaging === 'Labels'),
      default: () => '',
      hint: item => {
        if (item.drug && item.drug.n_pieces > 1) {
          return `Each box includes ${item.drug.n_pieces} items`
        }
      },
      readonly: item => !item.drug_id,
      'validators': [
        'required',
        'number',
        (field, value, item) => value <= item._n_available || `${field.text} has to be <= of ${item._n_available}`
      ]
    },
    {
      value: '_n_sheet',
      text: 'N. sheet / paper',
      deps: ['drug_id'],
      default: () => '',
      visible: (item) => item.drug && item.drug.packaging === 'Labels',
      readonly: item => !item.drug_id,
      hint: item => {
        if (item.drug && item.drug.n_pieces > 1) {
          return `Each sheet includes ${item.drug.n_pieces} labels`
        }
      },
      'validators': [
        'required',
        'number'
      ]
    },    
    {
      'value': 'n_pieces',
      'text': 'N. box / sheet',
      deps: ['_n_box', '_n_sheet'],
      default: item => (item.drug && item.drug.packaging === 'Labels') ? item._n_sheet : item._n_box,
      'type': 'number',
      'table': {
        'sortable': true,
        'filter': false
      },
      visible: false
      // readonly: item => !item.drug_id,
    }
  ],
  actions: ['remove']
}
